export default {
    // approval查询
    Approval: "/approval/show",
    // approval新增
    ApprovalAdd: "/approval/add",
    // approval删除
    ApprovalDel: "/approval/delete",
    // approval修改
    ApprovalUpdata: "/approval/update",
    // approval修改颜色
    ApprovalRecent: "/approval/recent",
    // 文件上传
    UploadFilePayment: "/approval/upload",
    // tenant信息
    Tenant: "/approval/tenant",
    // 账单汇总页
    getShowSummary: "/approval/summary/showSummary",
    // 账单汇总详情页
    getShowApprovalBySummary: "/approval/detail/showApprovalBySummary",
    // 账单util详情页三个月数据
    getIssuedCK: "/approval/utility/issuedCK",
    // 账单汇总Maintence详情页
    getShowApprovalOfMaintenance: "/approval/maintenance/showApprovalOfMaintenance",
    // requestApproval发送给老板
    requestApproval: "/approval/requestApproval",
    // 账单汇总Utiil详情页
    getShowApprovalOfUtil: "/approval/utility/showApprovalOfUtil",
    // 按钮printCheck
    getApprovalPrintCheck: "/approval/printCheck",
    // 查看文件
    getFile: "/approval/file",
    // 删除文件
    delFiles: "/approval/delFiles",
    // Pending Check全量下载
    exportSummaryCsv: "/approval/summary/exportSummaryCsv",
    // MainContractor 详情页
    getShowMainContractor:"/approval/mainContractor/showMainContractor",
    // GardenerAP 详情页
    getShowGardenerAP:"/approval/gardener/showGardener",
    // MajorProject 详情页
    getShowMajorProject:"/approval/majorProject/showMajorProject",
    // 账单详情总数
    showSummaryDetail:"/approval/summary/showSummaryDetail",
    // MonthlyWorke详情页
    showMonthlyWorkerDetail:"/approval/monthlyWorker/showMonthlyWorker",
    // MonthlyWorke二级详情页
    showMonthlyWorkerSubDetail:"/approval/monthlyWorker/showMonthlyWorkerDetail",
    // 账单详情总数
    showBusinessLicense:"/approval/businessLicense/showBusinessLicense",
    // maintenanceMaterialAp详情页
    ASmaintenanceMaterialAp:"/approval/maintenanceMaterialAp/maintenanceMaterialAp",
    // Insurance详情页
    ASInsuranceDetail: "/approval/insurance/showInsurance",
    // insurance页面根据propId来展示近三年得金额
    ASInsuranceAmount: "/approval/insurance/propByInsuranceAmount",
    // insruacne账单点击查看oneLineCashFlowData
    ASInsuranceCashFlow: "/approval/insurance/oneLineCashFlowData",
    // insurance页面根据propId来展示Unit详细信息
    ASInsurancePropDetails: "/common/propDetails",
    // insurance页面根据propId来展示Unit
    ASInsuranceUnitDetails: "/common/unitDetails",
    // insurance页面根据propId来展示Unit
    ASInsurancePolicyDetail: "/approval/insurance/insurancePolicyDetail",
    // 全量审批
    getAllRequestApproval:"/approval/summary/allRequestApproval",
    // 全量审批获取IDs
    getAllRequestApprovalIds:"/approval/summary/allRequestApprovalSize",
    // 全量审批获取IDs
    approvaldDeleteAllRequest:"/approval/deleteAllRequest",
    // ApprovalSummary模块导出账单
    // 导出maintenance类型账单csv
    exportApprovalOfMaintenanceCsv:"/approval/maintenance/exportApprovalOfMaintenanceCsv",
    // 导出BusinessLicense类型csv
    exportBusinessLicenseCsv:"/approval/businessLicense/exportBusinessLicenseCsv",
    // 导出csv  默认为pending页面
    exportApprovalBySummaryCsv:"/approval/detail/exportApprovalBySummaryCsv",
    // 导出uitlPayument账单csv
    exportApprovalOfUtilCsv:"/approval/utility/exportApprovalOfUtilCsv",
    // 导出MajorProject类型账单csv
    exportMajorProjectCsv:"/approval/majorProject/exportMajorProjectCsv",
    // 导出MainContractor类型账单csv
    exportMainContractorCsv:"/approval/mainContractor/exportMainContractorCsv",
    // 导出Gardener类型账单csv
    exportGardenerCsv:"/approval/gardener/exportGardenerCsv",
    // 导出MonthlyWorkerDetail三层页面csv
    exportMonthlyWorkerDetailCsv:"/approval/monthlyWorker/exportMonthlyWorkerDetailCsv",
    // 导出MaintenanceMaterialAp类型账单csv
    exportMaintenanceMaterialApCsv:"/approval/maintenanceMaterialAp/exportMaintenanceMaterialApCsv",
    // 导出Insurance类型账单csv
    exportInsuranceCsv:"/approval/insurance/exportInsuranceCsv",
    //printCashierCheck 按钮
    getPrintCashierCheck:"/approval/printCashierCheck",
};
